export default "__VITE_ASSET__BfsHj2iq__"